module.exports = __webpack_public_path__ + "assets/4fa8f3e5.wav";